import { Injectable } from '@angular/core';
import { GenericService, LoaderConfig } from './generic.service';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { ServerResponse } from '../models/ServerResponse';
import { UsersService } from './users.service';
import { RequestCacheConfig } from '../models/Request';

@Injectable({
    providedIn: 'root'
})
export class SupplierProductEconomicConditionsService {
    constructor( private _genericService: GenericService, private _user: UsersService) {

    }

    getProductElectricityEconomicCondition(id: string | number, loaderConfig: LoaderConfig | boolean = false): Observable<ServerResponse<any>> {
        return this._genericService.get(`${environment.apiUrl}ProductsElectricityEconomicConditions/${this._user.userCountryCode}/${id}`, loaderConfig, undefined, new RequestCacheConfig(10, undefined, 'seconds'));
    }

    getActiveElectricityEconomicConditions(productId: number, generalConditionId: number, particularConditionId: number, loaderConfig: LoaderConfig | boolean = false): Observable<ServerResponse<any[]>> {
        return this._genericService.post(`${environment.apiUrl}SupplierProducts/${this._user.userCountryCode}/${productId}/GeneralConditions/${generalConditionId}/ParticularConditions/${particularConditionId}/ElectricityEconomicConditions/Get/Active`, {}, undefined, loaderConfig);
    }

    getParticularCondition(productParticularConditionId: number, loaderConfig: LoaderConfig | boolean = false): Observable<ServerResponse<any>> {
        return this._genericService.get(`${environment.apiUrl}ProductsParticularConditions/${this._user.userCountryCode}/${productParticularConditionId}`, loaderConfig, undefined, new RequestCacheConfig(10, undefined, 'seconds'))
    }
}   